<template>
<div>
  <page-content-header
    :item="item"
  />
  <b-container>
    <b-row>
      <b-col>
        <page-content-creator
          :itemid="itemid"
          pos="top"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <node-element-local-tasks
          v-if="itemid"
          :itemid="itemid"
        />
        <div
          v-if="notpublished"
          class="messages warning"
        >Not published</div>
        </b-col>
      </b-row>
  </b-container>
  <section class="page-body">
    <page-content-wysiwg-content
      v-if="hasBody"
      :item="item"
    />
  </section>
  <section class="people-group-set" :class="[selectedcolorThemeOption]">
  <div v-for="(group, groupIndex) in filteredGroups" :key="groupIndex" class="people-group">
    <b-container>
      <b-row>
        <b-col>
          <div class="people-group-category-header" v-if="getGroupTitle(group)">
            <div class="title">
              <h2>{{ getGroupTitle(group) }}</h2>
            </div>
            <div v-if="getGroupDescription(group)" class="people-group-category-description">
              {{ getGroupDescription(group) }}
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
            <div class="people-display" :class="`${selectedlayoutStyle} ${ getGroupGridStyle(group) }`">
              <div class="speaker-item" v-for="(person, index) in getPeople(group)" :key="index">
                <div class="profile-teaser">
                  <div class="profile-image">
                    <div class="image-container-outer" @click="setShowModal(person, index)" :class="isRound(selectedAspectRatio)">
                      <AImage
                        :img="getImage(person)"
                        :placeholder-url="require('assets/image-placeholders/person-placeholder.svg')"
                        :ratio="selectedAspectRatio"
                        preset="peoplegroupperson"
                        cover
                      />

                    </div>
                  </div>
                  <template v-if="layoutIsGrid(selectedlayoutStyle)">
                    <div class="profile-content-container" @click="setShowModal(person, index)">
                      <div v-if="getName(person)" class="profile-name">
                        <h3>{{ getName(person) }}</h3>
                      </div>
                      <div class="profile-info">
                      <span class="profile-position">
                        {{ getPosition(person) }}
                      </span>
                      <span v-if="getOrganisation(person) && getPosition(person)">,</span>
                      <span class="profile-organisation">
                        {{ getOrganisation(person) }}
                      </span>
                      </div>
                    </div>
                  </template>
                  <template v-else>
                    <div class="profile-content-container">
                      <div v-if="getName(person)" class="profile-name">
                        <h3>{{ getName(person) }}</h3>
                      </div>
                      <div class="profile-info">
                        <span class="profile-position">
                          {{ getPosition(person) }}
                        </span>
                        <span v-if="getOrganisation(person) && getPosition(person)">,</span>
                        <span class="profile-organisation">
                          {{ getOrganisation(person) }}
                        </span>
                      </div>
                      <div v-html="person.description" class="person-description" />
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <sp-people-group-modal
      v-if="modalPerson"
      v-model="showModal"
      :person="modalPerson"
    />
  </section>
  <b-container>
      <b-row>
        <b-col>
          <page-content-creator
            :itemid="itemid"
            pos="bottom"
          />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
  import { asyncLoader, pageMixin, getPreloadImageUrlPromises } from "../../special-pages-common";

  function preloadImageUrls({ store, route, router }) {
    if ( !route || !store ) {
      return Promise.resolve(false)
    }
    applogger.debug('sp-people-group: image url loading started')
    return store.dispatch('node/load', { nid: route.path })
      .then(item => {
        return getPreloadImageUrlPromises(
          store,
          ['banner', 'peoplegroupperson'],
          [[item.field_f_content_header_img], item.field_f_sp_pg_image]
        )
      })
      .then(_ => {
        applogger.debug('sp-people-group: image url loading complete')
      })
      .catch(err => {
        applogger.error(`sp-people-group: image url loading failed`)
      })
  }

  export default {
    name: 'page-content-type-sp_people_group',
    asyncComponents: [
      'sp-people-group-modal',
      'sp-people-group-placeholder'
    ],
    mixins: [
      pageMixin
    ],
    asyncData: (args) => {
      return args.store.dispatch('promisePool', {
        name: `page-content-type_sp_people_group--${args.route.path}`,
        resolve: () => preloadImageUrls(args)
          .then(() => asyncLoader(args))
      })
    },
    data() {
      return {
        selectedcolorThemeOption: 'default-style',
        personImageAspectRatio: '3-4',
        selectedlayoutStyle: 'grid',
        selectedAspectRatio: '1-1-round',
        showModal: false,
        modalPerson: null,
      }
    },
    methods: {
      setShowModal(person, index) {
        this.$set(this, 'modalPerson', JSON.parse(JSON.stringify(person)))
        this.$set(this, 'showModal', true)
      },
      getGroupTitle(group) {
        return group.title
      },
      getGroupDescription(group) {
        return group.description
      },
      getGroupGridStyle(group) {
        return group.gridStyle
      },
      getGroupListStyle(group) {
        return group.listStyle
      },
      getPeople(group) {
        return group.people
      },
      getName(person) {
        return person.name
      },
      getPosition(person) {
        return person.job
      },
      getOrganisation(person) {
        return person.organisation
      },
      hasImage(person) {
        return person.image && person.image.filestorename && person.image.filepath
      },
      getImage(person) {
        return person.image
      },
      isRound(selectedAspectRatio) {
        if (selectedAspectRatio == '1-1-round') {
          return 'circle'
        } else
          return false
      },
      layoutIsGrid(selectedlayoutStyle) {
        if (selectedlayoutStyle == 'grid') {
          return 'true'
        } else
          return false
      },
      layoutIsList(selectedlayoutStyle) {
        if (selectedlayoutStyle == 'list') {
          return 'true'
        } else
          return false
      },
    },
    computed: {
      groups() {
        return [
          {
            listStyle: 'standard-list',
            gridStyle: 'grid-4',
            title: '',
            description: '',
            people: Object.keys(this.item['field_t_sp_pg_name']).map(i => ({
              name: this.item['field_t_sp_pg_name'][i],
              job: this.item['field_t_sp_pg_job'][i],
              organisation: this.item['field_t_sp_pg_organisation'][i],
              description: this.item['field_t_sp_pg_description'][i],
              contactUrl: (this.item['field_l_sp_pg_contact_url'][i] && this.item['field_l_sp_pg_contact_url'][i]['url']) ? this.item['field_l_sp_pg_contact_url'][i]['url'] : null,
              contactPhone: (this.item['field_p_sp_pg_contact_phone'][i] && this.item['field_p_sp_pg_contact_phone'][i]['number']) ? this.item['field_p_sp_pg_contact_phone'][i]['number'] : null,
              image: (this.item['field_f_sp_pg_image'][i]) ? {
                data: {
                  title: this.item['field_f_sp_pg_image'][i].title,
                  alt: this.item['field_f_sp_pg_image'][i].alt
                },
                ...this.item['field_f_sp_pg_image'][i]
              } : null,
            })).filter(person => person.name),
          }
        ]
      },
      filteredGroups() {
        return this.groups.filter(group => this.getPeople(group).length > 0)
      }
    }
  }
</script>



<style lang="scss" scoped>
@import '~@scss/custom.scss';

  @mixin transform-scale($x:1, $y:1) {
    -webkit-transform: scale($x, $y);
    -moz-transform: scale($x, $y);
    -o-transform: scale($x, $y);
    -ms-transform: scale($x, $y);
    transform: scale($x, $y);
  }

  @mixin responsive-ratio($x,$y, $pseudo: false) {
    $padding: unquote( ( $y / $x ) * 100 + '%' );
    @if $pseudo {
        &:before {
            @include pseudo($pos: relative);
            width: 100%;
            padding-bottom: $padding;
        }
    } @else {
        padding-bottom: $padding;
    }
  }

  ::v-deep .image-container-outer {
    position: relative;
    overflow: hidden;
    z-index: 1;
    cursor: pointer;
    &.circle {
      border-radius: 100%;
      .low-res {
        clip-path: circle(50% at 50% 50%);
      }
    }
    &:hover {
      .a-image {
        @include transform-scale (1.1, 1.1);
      }
    }
    .a-image {
      @include transition (transform .75s);
      background-color: var(--main-image-background-color);
      transform: perspective(1px) scale(1);
      transform-origin: center;
    }
  }

  //people group set
  .people-group-set {
    position: relative;
    .people-group {
      padding:3em 0em;
    }
  }

  //layout grid display
  .people-display {
    display: grid;
    grid-gap: 2.5em;
    margin-bottom: 2.5em;
    &.grid-2 {
      grid-template-columns: repeat(2, 1fr);
      @include media-breakpoint-up(md) {
        grid-template-columns: repeat(2, 1fr);
      }
    }
    &.grid-3 {
      grid-template-columns: repeat(2, 1fr);
      @include media-breakpoint-up(md) {
        grid-template-columns: repeat(3, 1fr);
      }
    }
    &.grid-4 {
      grid-template-columns: repeat(2, 1fr);
      @include media-breakpoint-up(lg) {
        grid-template-columns: repeat(4, 1fr);
      }
    }
    &.grid-5 {
      grid-template-columns: repeat(2, 1fr);
      @include media-breakpoint-up(md) {
        grid-template-columns: repeat(3, 1fr);
      }
      @include media-breakpoint-up(xl) {
        grid-template-columns: repeat(5, 1fr);
      }
    }
   &.grid {
      .profile-image {
        margin-bottom:1.5em;
      }
      .profile-content-container {
        text-align: center;
      }
    }
  }


  //layout list display
  .people-display {

    &.split-list {
      grid-template-columns: repeat(2, 1fr);
      .speaker-item {
        padding-bottom: 2em;
        border-bottom: 1px solid;
        border-color: var(--main-border-color);
      }
      .profile-teaser {
        flex-direction: row;
        display: flex;
      }
      .profile-image {
        min-width: 40%;
        margin-right: 2em;
      }
      .profile-teaser {
        .profile-content-container {
          text-align: left;
        }
      }
      .profile-info {
        margin-bottom:1rem;
      }
    }
    &.standard-list {
      grid-template-columns: repeat(1, 1fr);
      .speaker-item {
        padding-bottom: 2em;
        border-bottom: 1px solid;
        border-color: var(--main-border-color);
      }
      .profile-teaser {
        flex-direction: row;
        display: flex;
      }
      .profile-image {
        min-width: 25%;
        margin-right: 2em;
      }
      .profile-teaser {
        .profile-content-container {
          text-align: left;
        }
      }
      .profile-info {
        margin-bottom:1rem;
      }
    }

    &.list {
      .profile-info {
        margin-bottom:1rem;
      }
    }
  }

  .people-group-category-header {
    text-align: center;
    color: var(--main-text-color);
    margin-bottom: 2.5em;
  }

  .speaker-item {
    overflow: hidden;
  }

  .profile-teaser {
    height: 100%;
    display: flex;
    flex-direction: column;
    color: var(--main-text-color);
    .title {
      h3 {
        font-size: 1.7em;
      }
    }

    .profile-content-container {
      height: 100%;
      cursor:pointer;
    }

    .profile-info {
        font-style: italic;
        font-size: 1.1em;
        opacity: .5;
    }
  }

  //image options, we also import aspect ratios from common
  .profile-image {

  }
  .placeholder-container{
    display: flex;
    position: absolute;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    width: 100%;
    z-index: 2;
   ::v-deep svg {
      path {
        fill: var(--main-background-color);
      }
    }
  }
</style>
